/* eslint-disable */
import Cookie from 'js-cookie';

const allowedReferrers = [
  'yandex_direct',
  'yandex_direct_brand',
  'yandex_direct_kz',
  'google_adwords',
  'google_adwords_brand',
  'google_adwords_kz',
];

let isAllowed = false;

export function initYandexMetrika() {
  const referrer = Cookie.get('referrer');
  isAllowed = allowedReferrers.includes(referrer);
  if (!isAllowed) {
    return;
  }
  (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    (k = e.createElement(t)),
      (a = e.getElementsByTagName(t)[0]),
      (k.async = 1),
      (k.src = r),
      a.parentNode.insertBefore(k, a);
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');
  ym(34784125, 'init', {
    clickmap: false,
    trackLinks: false,
    accurateTrackBounce: false,
    webvisor: false,
  });
}

export function sendEvent(name) {
  if (isAllowed && window.ym) {
    window.ym(34784125, 'reachGoal', name);
  }
}
